import { FormTable } from '@connected/form-fields/components/form-table';
import { useMemo } from 'react';

import { useCondition } from '@/config/conditions';

import type { DeviceFormValues } from '../../distribution-board-device/types/hook-types';

import { useFinalCircuitProtectiveDevice } from '../../distribution-board-device/hooks';
import { createImpedanceColumns } from './impedance-columns';

type ImpedanceMeasurementsTableProps = {
    electricalProjectVersionId: string;
    electricalProjectDistributionBoardId: string;
    currentPage?: number;
    onPageChange?: (page: number) => void;
};

export function ImpedanceMeasurementsTable({
    electricalProjectVersionId,
    electricalProjectDistributionBoardId,
    currentPage,
    onPageChange,
}: ImpedanceMeasurementsTableProps) {
    // Use conditions to determine feature flags
    const enableExtendedRiso = useCondition('canAccessExtendedRiso');
    const enableImpedanceMeasurementsPage = useCondition('canAccessImpedanceMeasurementsPage');

    const hookResult = useFinalCircuitProtectiveDevice({
        electricalProjectVersionId,
        electricalProjectDistributionBoardId,
        enableExtendedRiso,
        enableImpedanceMeasurementsPage,
    });

    // Create column definitions for impedance measurements
    const columns = useMemo(
        () => createImpedanceColumns({
            form: hookResult.form,
            createPatcher: hookResult.createPatcher,
        }),
        [
            hookResult.form,
            hookResult.createPatcher,
        ],
    );

    if (hookResult.devices.length === 0) {
        return <div className="text-center py-4 text-muted-foreground">Geen apparaten gevonden</div>;
    }

    return (
        <FormTable<DeviceFormValues>
            key={hookResult.formKey}
            form={hookResult.form as any}
            fieldArrayName="devices"
            columns={columns}
            pageSize={10}
            currentPage={currentPage}
            onPageChange={onPageChange}
            emptyMessage="Geen apparaten gevonden"
            getRowKey={row => row.id}
        />
    );
}
